import { gsap, ScrollTrigger, screenSm } from './1.1_animations-defaults.js';

const SECTION_ID = 'home-page-section-d';

const CARD_CONTAINER_CLASS = 'card-container';
const CARD_CLASS = 'card';
const IMAGE_CLASS = 'image';

const LINE_CLASS = 'line';

// const DESKTOP_IMAGE_MIN_WIDTH = 36.2;
const DESKTOP_IMAGE_MIN_WIDTH = 26.2;
const MOBILE_IMAGE_MIN_WIDTH = 53.3333333333;
//const DESKTOP_IMAGE_MAX_WIDTH = 57.25;
const DESKTOP_IMAGE_MAX_WIDTH = 48;

class AnimationsHomeSectionD {
    constructor() {
        this._section = document.getElementById(SECTION_ID);

        this._section && this._run();
    }
    _run = () => {
        this._media = gsap.matchMedia();
        this._cardContainer = this._section.querySelector(`.${CARD_CONTAINER_CLASS}`);

        this._cards = this._section.querySelectorAll(`.${CARD_CLASS}`);
        this._images = this._section.querySelectorAll(`.${IMAGE_CLASS}`);

        this._media.add(
            {
                isDesktop: `(min-width: ${screenSm}px)`,
                isMobile: `(max-width: ${screenSm - 1}px)`,
                reduceMotion: '(prefers-reduced-motion: reduce)',
            },
            this._createAnimationTimeline,
        );
    };
    _createAnimationTimeline = (context) => {
        let { isDesktop, isMobile, reduceMotion } = context.conditions;
        let easing = 'sliderEase';
        //ScrollTrigger.refresh();
        this._cards.forEach((card) => {
            const image = card.querySelector(`.${IMAGE_CLASS}`);
            const line = card.querySelector(`.${LINE_CLASS}`);

            gsap.set(card, {
                height: getComputedStyle(card).height,
            });
            gsap.set(image, {
                flexBasis: isDesktop ? `${DESKTOP_IMAGE_MIN_WIDTH}%` : '',
                width: isDesktop ? '' : `${MOBILE_IMAGE_MIN_WIDTH}%`,
            });

            gsap.to(image, {
                flexBasis: isDesktop ? `${DESKTOP_IMAGE_MAX_WIDTH}%` : '',
                width: isDesktop ? '' : '100%',
                ease: easing,

                scrollTrigger: {
                    trigger: card,
                    start: isDesktop ? 'top 90%' : 'top 90%',
                    end: isDesktop ? 'top top' : 'top 20%',
                    markers: false,
                },
            });

            gsap.set(line, {
                scaleX: 0,
            });
            gsap.to(line, {
                scaleX: 1,
                ease: easing,
                scrollTrigger: {
                    trigger: card,
                    start: isDesktop ? 'bottom bottom' : 'bottom 90%',
                    end: isDesktop ? 'bottom 60%' : 'bottom 70%',
                    markers: false,
                },
            });
        });
    };
}
const animationsHomeSectionD = new AnimationsHomeSectionD();
